export default __webpack_public_path__ + "static/media/problema-07.205d9fce.webp";